import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles<Theme>(theme => ({
  headerRoot: {
    position: 'relative',
    padding: '1.25rem 2rem'
  },

  bodyRoot: {
    position: 'relative',
    padding: '2rem'
  },

  toggle: {
    position: 'absolute',
    top: '0.25rem',
    left: '0.3rem',
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.primary.main,
    cursor: 'pointer',
    userSelect: 'none',
    height: 26
  },

  toggleBtn: {
    position: 'absolute',
    top: '0.25rem',
    left: '0',
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.primary.main,
    cursor: 'pointer',
    userSelect: 'none'
  },

  icon: {
    marginRight: '0.5rem'
  }
}))

export default useStyles
